// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","488":"8fd8651a","513":"1426e89b","625":"84efc53e","706":"cc727622"}[chunkId] + ".chunk.js";
};